<template>
  <div>
    <component
      :is="loading ? PrmIconField : 'div'"
    >
      <PrmPassword
        :model-value="modelValue"
        toggle-mask
        :feedback="false"
        :disabled="loading || disabled"
        :placeholder="placeholder"
        :required="required"
        style="width: 100%"
        :class="{
          'p-invalid': !!invalid,
        }"
        :input-style="{
          cursor: 'text',
        }"
        @update:model-value="emit('update:modelValue', $event as string)"
      />
      <PrmInputIcon
        v-if="loading"
        class="pi pi-spinner"
      />
    </component>
    <span
      v-if="!!errorMessage"
      class="input-wrapper-error"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script setup lang="ts">
import PrmIconField from '@NitrexGroup/primevue/iconfield';
import PrmInputIcon from '@NitrexGroup/primevue/inputicon';
import PrmPassword from '@NitrexGroup/primevue/password';

defineProps<{
  modelValue?: string | null,
  loading?: boolean,
  disabled?: boolean,
  invalid?: boolean,
  placeholder?: string,
  errorMessage?: string,
  required?: boolean,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void,
}>();

</script>
